const accessProductManagement = {

    PRODUCT_LIST: { name: 'Product', path: '/product-list' },
    ADD_PRODUCT: { name: 'Add Product', path: '/create-product' },
    UPDATE_PRODUCT: { name: 'Update Product', path: '/edit-product' },
    DELETE_PRODUCT: { name: 'Delete Product', path: '/delete-product' },
    PRODUCT_DETAILS: { name: 'Product Details', path: '/product-details' },
    PRODUCT_REVIEWS: { name: 'Product Review', path: '/product-review' },

    PRICING_LIST: { name: 'Pricing', path: '/pricing-list' },
    PRICING_CONFIGURATION: { name: 'Pricing Configuration', path: '/pricing-configuration' },

    RECIPE_LIST: { name: 'Recipe', path: '/recipe-list' },
    RECIPE_DETAILS: { name: 'Recipe Details', path: '/recipe-details' },
    RECIPE_APPROVAL: { name: 'Recipe Approval', path: '/recipe-approval' },
    DELETE_RECIPE: { name: 'Delete Recipe', path: '/delete-recipe' },

}

export default accessProductManagement;